import { OpenAI } from 'openai'

const openai = new OpenAI({
  apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true,
})

export const fetchMenuFromImage = async (base64image: string) => {
  const response = await openai.chat.completions.create({
    model: 'gpt-4o',
    temperature: 0,
    max_tokens: 4096,
    messages: [
      {
        role: 'system',
        content:
          'You are an assistant that speaks JSON. Do not write normal text. Your task is to read the menu from the image and convert it to a JSON format that user wants. Your responses must be parsable with JSON.parse().',
      },
      {
        role: 'user',
        content:
          "Respond with an array of items. Provide your response as an array of items and categories: Example response: [{ itemType: 'drink', ... }, ...]. Do not add currency sign to the price. Use '.' as decimal sign. Do not leave trailing commas.",
      },
      {
        role: 'user',
        content: "Example response: [{itemType: 'drink', price: '2.5', translations: {en: 'Coca Cola'}, ...}, ...]",
      },
      {
        role: 'user',
        content: [
          {
            type: 'text',
            text: `We are trying to get data from an image,
            that displays restaurant menu and convert it to a json with format that we use.
            I will provide image first, and then our json format.
          `,
          },
          {
            type: 'image_url',
            image_url: {
              url: base64image,
            },
          },
          {
            type: 'text',
            text: `Please parse the menu from the image and provide the JSON format that we use.`,
          },
        ],
      },
    ],
    functions: [
      {
        name: 'parseMenu',
        parameters: {
          type: 'object',
          properties: {
            data: {
              type: 'array',
              items: {
                type: 'object',
                properties: {
                  translations: {
                    type: 'object',
                    properties: {
                      title: {
                        $ref: '#/$defs/Translation',
                      },
                      description: {
                        $ref: '#/$defs/Translation',
                      },
                    },
                  },
                  itemType: {
                    type: 'string',
                    enum: ['main', 'side_dish', 'drink'],
                  },
                  type: {
                    type: 'string',
                    enum: ['menuItem', 'editableText'],
                  },
                  price: {
                    type: 'string',
                    pattern: '^\\d+(\\.\\d+)?$',
                  },
                  isAlcohol: {
                    type: 'boolean',
                  },
                  extras: {
                    type: 'array',
                    items: {
                      type: 'object',
                      properties: {
                        translations: {
                          type: 'object',
                          properties: {
                            name: {
                              $ref: '#/$defs/Translation',
                            },
                          },
                        },
                        price: {
                          type: 'string',
                          pattern: '^\\d+(\\.\\d+)?$',
                        },
                      },
                      required: ['name'],
                    },
                  },
                  options: {
                    type: 'array',
                    items: {
                      type: 'object',
                      properties: {
                        translations: {
                          type: 'object',
                          properties: {
                            optionName: {
                              $ref: '#/$defs/Translation',
                            },
                          },
                        },
                        optionList: {
                          type: 'array',
                          items: {
                            type: 'object',
                            properties: {
                              translations: {
                                type: 'object',
                                properties: {
                                  name: {
                                    $ref: '#/$defs/Translation',
                                  },
                                },
                              },
                              price: {
                                type: 'string',
                                pattern: '^\\d+(\\.\\d+)?$',
                              },
                            },
                            required: ['name'],
                          },
                        },
                        optionChoiceLimit: {
                          type: 'string',
                          pattern: '^\\d+$',
                        },
                      },
                      required: ['optionChoiceLimit'],
                    },
                  },
                },
              },
              required: ['translations', 'itemType', 'type', 'price', 'isAlcohol', 'extras', 'options'],
            },
          },
          $defs: {
            Translation: {
              type: 'object',
              properties: {
                en: {
                  type: 'string',
                },
              },
              required: ['en'],
            },
          },
        },
      },
    ],
    function_call: { name: 'parseMenu' },
  })

  return response
}
